if (!customElements.get('jc-sticky-buy-bar')) {
  customElements.define(
    'jc-sticky-buy-bar',
    class JCStickyBuyBar extends HTMLElement {
      connectedCallback() {
        this.target = document.querySelector('.jc-product-info');
        if (!this.target) return;

        this.observer = new IntersectionObserver(([entry]) => {
          this.classList.toggle('jc-sticky-buy-bar--visible', !entry.isIntersecting);
        });
        this.observer.observe(this.target);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}
